import { Box, Button, HStack, Text } from '@chakra-ui/react'

/** Shared "Mark X as deceased?" confirm used by every door step that offers Deceased. */
export function ConfirmDeceased({ name, onConfirm, onCancel }: {
  name: string; onConfirm: () => void; onCancel: () => void
}) {
  return (
    <Box borderWidth="1px" borderColor="border" borderRadius="md" p={3} bg="bg.subtle">
      <Text mb={2}>{`Mark ${name} as deceased? They'll be dropped from all future walks.`}</Text>
      <HStack gap={2}>
        <Button minH="44px" bg="accent" color="accent.fg" onClick={onConfirm}>Mark deceased</Button>
        <Button minH="44px" variant="outline" borderColor="border" onClick={onCancel}>Cancel</Button>
      </HStack>
    </Box>
  )
}
